(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceBillingConfig', InsuranceBillingConfig);

    InsuranceBillingConfig.$inject = ['$resource'];

    function InsuranceBillingConfig($resource) {
        var resourceUrl = 'api/insurance-billing-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'byFacility': {method: 'GET', url: 'api/insurance-billing-configs/by-facility'},
            'filter': {url:'api/insurance-billing-configs/filter', method: 'GET', isArray: true}
        });
    }
})();
